import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

export interface FareCalendarPayload {
    queryContext: {
        startDate: string
        daysCount: number
        cabin: string
        origin: string
        destination: string
        paxTypeContext: {
            adultCount: number
            childCount: number
            infantCount: number
        }
    }
    demandContext: {
        partnerId: string
    }
}

export interface FareCalendarDayData {
    [date: string]: {
        amount: number
        fareCategory: string
        events?: any[]
    }
}

export interface FareCalendarMonthData {
    [month: string]: {
        cheapest: number
        average: number
        [key: string]: any
    }
}

export interface FareCalendarResponse {
    tripType: string
    dayData: {
        amount: number
        date: string
        fareCategory: string
        farePresent: boolean
    }[]
}

export const calendarApi = createApi({
    reducerPath: 'calendarApi',
    baseQuery: fetchBaseQuery({
        baseUrl: '/',
        prepareHeaders: headers => {
            headers.set('product', 'air')
            headers.set('channel', 'WEB')
            headers.set('Accept', 'application/json')
            headers.set('Content-Type', 'application/json')
            return headers
        }
    }),
    endpoints: builder => ({
        getFareCalendar: builder.query<
            FareCalendarResponse,
            { payload: FareCalendarPayload; perPaxPricingRequired: boolean }
        >({
            query: ({ payload, perPaxPricingRequired }) => ({
                url: `/flights/v1/calendar/tab/fares?perPaxPricingRequired=${!!perPaxPricingRequired}`,
                method: 'POST',
                body: payload
            })
        })
    })
})

export const { useGetFareCalendarQuery, useLazyGetFareCalendarQuery } = calendarApi
